import clsx from 'clsx';
import { match } from 'ts-pattern';

import { Button } from '@components/Button';
import { Title } from '@components/Title';

import { Image } from '../Image';
import { Typography } from '../Typography';

interface FeatureProps {
  variant?: 'default' | 'reversed' | 'title-left';
  data?: Feature;
}

export const Feature: React.FC<FeatureProps> = ({
  variant = 'default',
  data,
}) => {
  return match(variant)
    .with('default', 'reversed', () => (
      <div className="feature flex flex-col gap-16">
        <Title variant="center" data={data?.title} />

        <div
          className="flex flex-wrap items-center gap-16 data-[variant=reversed]:flex-row-reverse md:gap-8"
          data-variant={variant}
        >
          <div className="min-w-full flex-1 lg:min-w-[auto]">
            <Typography variant="body1" markdown>
              {data?.content}
            </Typography>
          </div>

          {data?.image !== null && (
            <Image
              src={data?.image}
              className={clsx(
                'min-h-[20rem] min-w-[100vw] flex-1 object-cover lg:min-w-[auto] lg:rounded-md',
                variant === 'default' && '-ml-8 lg:ml-auto',
                variant === 'reversed' && '-mr-8 lg:mr-auto',
              )}
            />
          )}
        </div>
      </div>
    ))
    .with('title-left', () => (
      <div
        className="feature flex flex-wrap items-center gap-16"
        data-variant={variant}
      >
        <div className="flex min-w-full flex-1 flex-col items-start gap-6 lg:min-w-[auto]">
          <Title variant="start" data={data?.title} />

          <Typography variant="body1" markdown>
            {data?.content}
          </Typography>

          {data?.link && (
            <Button size="large" href={data?.link?.href}>
              {data?.link?.label}
            </Button>
          )}
        </div>

        {data?.image !== null && (
          <Image
            src={data?.image}
            className={clsx(
              '-ml-8 min-h-[20rem] min-w-[100vw] flex-1 object-cover lg:ml-auto lg:min-w-[auto] lg:rounded-md',
            )}
          />
        )}
      </div>
    ))
    .exhaustive();
};
